import $ from 'jquery';

export default function () {
    $(document).ready(() => {
        (function () {
            var $body = $('.article-content.post-body');
            var $firstChild = $($('.article-content.post-body .text-wrapper').children()[1]);

            if ($firstChild.filter('figure').length > 0) {
                $firstChild.css({
                    marginTop: '38px'
                });
                $body.addClass('no-accent');
            }
        })();
    });
}

